import { render, staticRenderFns } from "./ScanFitting.vue?vue&type=template&id=5224fcae&"
import script from "./ScanFitting.vue?vue&type=script&lang=js&"
export * from "./ScanFitting.vue?vue&type=script&lang=js&"
import style0 from "./ScanFitting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports